// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-sidenav {
  min-width: 270px !important;
  max-width: 270px !important;
}

.mat-mdc-button > .mat-icon {
  margin-right: 0px;
}

.spacer {
  flex: 1 1 auto;
}

.link-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem;
}

.splashGradient {
  background: rgb(36, 46, 19);
  background: linear-gradient(360deg, rgb(36, 46, 19) 0%, rgb(102, 129, 56) 26%);
}

.mat-drawer-container {
  height: calc(100vh - 64px) !important;
  background-color: #cccccc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.bottom-page {
  position: absolute;
  bottom: 0;
  left: 0;
}

@media only screen and (max-width: 599px) {
  .mat-drawer-container {
    height: calc(100vh - 56px) !important;
    background-color: #cccccc;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/main/public/public-main.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,2BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA;EACA,8EAAA;AACF;;AAEA;EACE,qCAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AACF;;AAEA;EACE;IACE,qCAAA;IACA,yBAAA;IACA,2BAAA;IACA,4BAAA;IACA,sBAAA;EACF;AACF","sourcesContent":["mat-sidenav {\r\n  min-width: 270px !important;\r\n  max-width: 270px !important;\r\n}\r\n\r\n.mat-mdc-button>.mat-icon {\r\n  margin-right: 0px;\r\n}\r\n\r\n.spacer {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.link-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 0.75rem;\r\n}\r\n\r\n.splashGradient {\r\n  background: rgb(36,46,19);\r\n  background: linear-gradient(360deg, rgba(36,46,19,1) 0%, rgba(102,129,56,1) 26%);\r\n}\r\n\r\n.mat-drawer-container {\r\n  height: calc(100vh - 64px) !important;\r\n  background-color: #cccccc;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n.bottom-page {\r\n  position: absolute; \r\n  bottom: 0; \r\n  left: 0;\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n  .mat-drawer-container {\r\n    height: calc(100vh - 56px) !important;\r\n    background-color: #cccccc;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
